import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import TickerRow from './TickerRow';

export default function TravelerSection({
  adults,
  children,
  childrenAges,
  onAdultsChange,
  onChildrenChange,
  onChildAgeChange,
  onChildAgeBlur,
  tickerSize = 'large',
  inputSx,
  inputWidth = 200,
}) {
  return (
    <Stack gap={2}>
      <TickerRow label="Adults" value={adults} onChange={onAdultsChange} size={tickerSize} />
      <TickerRow label="Children" value={children} onChange={onChildrenChange} size={tickerSize} />
      {childrenAges.map((age, idx) => (
        <Stack key={idx} direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant={tickerSize === 'small' ? 'body2' : 'body1'} color={tickerSize === 'small' ? 'text.secondary' : undefined}>
            Child {idx + 1} Age
          </Typography>
          <TextField
            value={age}
            onChange={e => onChildAgeChange(idx, e.target.value)}
            onBlur={() => onChildAgeBlur(idx)}
            size="small"
            placeholder="12"
            sx={{ ...inputSx, width: inputWidth }}
            inputProps={{ inputMode: 'numeric' }}
          />
        </Stack>
      ))}
    </Stack>
  );
}
